module.exports = __webpack_public_path__ + "static/media/Transparent.44e41a91.png";